// This is the only HQ UI configuration boundary. Views and CSS are shared.
const first = window.location.pathname.split('/')[1];
const legacy = ({'floorball.danielfaldt.se':'floorball','hockeyhq.danielfaldt.se':'hockey'})[window.location.hostname];
const sport = ['floorball','hockey'].includes(first) ? first : legacy || 'floorball';
document.body.dataset.hqSport = sport;
const basename = first === sport ? `/${sport}` : legacy === sport ? '' : `/${sport}`;
export const HQ = {
  sport, basename, brand:sport === 'hockey' ? 'Hockey HQ' : 'Floorball HQ',
  api:`/${sport}/api`, dataApi:sport === 'hockey' ? '/hockey/api/hq' : '/floorball/api',
  storagePrefix:`${sport}-hq`,
  validFavorite:id => sport === 'hockey' ? typeof id === 'string' && id.length <= 120 : Number.isInteger(id) && id > 0,
  favoriteBody:ids => sport === 'hockey' ? {team_names:ids} : {team_ids:ids},
  favoriteIds:data => data.team_ids || data.team_names || [],
  normalizeFavorites:data => ({...data,team_ids:data.team_ids || data.team_names || []}),
};
document.title = HQ.brand;
export const leagueCompetition = league => sport === 'hockey' ? league?.key : league?.source_url?.match(/\/serie\/(\d+)\//)?.[1];
export const requestedHockeyMatch = params => sport === 'hockey' && params.get('simulation') && params.get('id')
  ? `hq://hockey/${params.get('simulation')}/${params.get('id')}/laguppstallning` : null;

// Preserve Hockey's existing deep-link query names alongside the shared HQ names.
if (sport === 'hockey') {
  const query = new URLSearchParams(window.location.search);
  if (!query.has('serie') && query.has('simulation') && !window.location.pathname.endsWith('/match')) query.set('serie', query.get('simulation'));
  if (query.get('tab') === 'schedule') query.set('vy','spelschema');
  if (query.get('mine') === '1' && window.location.pathname.endsWith('/series')) query.set('mina','1');
  const search = query.toString();
  if (search !== window.location.search.slice(1)) window.history.replaceState(null,'',window.location.pathname+(search?'?'+search:'')+window.location.hash);
}

export const sportsimPath = path => (sport === 'hockey' && path.startsWith('/matches?') ? '/hockey/api/hq/sportsim' : `${HQ.api}/sportsim`) + path;
